<template>
  <q-avatar
    :icon="icon"
    :size="size"
    :color="color"
    :square="square"
    :rounded="rounded"
    :text-color="textColor"
  />
</template>

<script>
/**
 * size: {string} 'xs', 'sm', 'md', 'lg', 'xl'
 */

export default {
  name: 'Avatar',
  props: {
    icon: { type: String, required: true },
    size: { type: String },
    color: { type: String },
    square: { type: String },
    rounded: { type: Boolean },
    textColor: { type: String, default: 'standard' },
  },
};
</script>

<style lang="scss" scoped></style>
